import checkURL from '@/helpers/checkURL'
import {
  ELinkRel,
  ELinkType,
  EProtocol,
  ETarget,
  TLinkFormData,
} from '../containers/LinkForm/types'

export const getFormData = (
  linkEl: CKEDITOR.dom.element | null
): TLinkFormData => {
  const text = linkEl?.getText() || ''
  const href = linkEl?.getAttribute('href')

  if (href?.startsWith('#')) {
    const formData: TLinkFormData = {
      linkType: ELinkType.LINK_ANCHOR,
      text,
      anchorId: href.slice(1),
    }

    return formData
  }

  if (href?.startsWith('mailto:')) {
    const parsedUrl = checkURL(href) ? new URL(href) : null

    const formData: TLinkFormData = {
      linkType: ELinkType.EMAIL,
      email: parsedUrl?.pathname || '',
      subject: parsedUrl?.searchParams.get('subject') || '',
      body: parsedUrl?.searchParams.get('body') || '',
      text,
    }

    return formData
  }

  if (href?.startsWith('tel:')) {
    const formData: TLinkFormData = {
      linkType: ELinkType.PHONE,
      phoneNumber: href.slice(4),
      text,
    }

    return formData
  }

  const parsedUrl = href && checkURL(href) ? new URL(href) : null

  let protocol = parsedUrl?.protocol as EProtocol | undefined

  if (!protocol || !Object.values(EProtocol).includes(protocol)) {
    protocol = EProtocol.HTTPS
  }

  let rel = linkEl?.getAttribute('rel') as ELinkRel | undefined

  if (!href) {
    rel = ELinkRel.NOFOLLOW
  } else if (rel && !Object.values(ELinkRel).includes(rel)) {
    rel = ELinkRel.NOFOLLOW
  }

  let target = linkEl?.getAttribute('target') as ETarget | undefined

  if (!target || !Object.values(ETarget).includes(target)) {
    target = ETarget.NOT_SET
  }

  const formData: TLinkFormData = {
    linkType: ELinkType.LINK,
    href: parsedUrl?.toString() || '',
    rel: rel || null,
    text,
    protocol,
    target,
  }

  return formData
}
